import { Stepper } from "slotworks/integration/revolver/schema/init-record-schema";
import slotDefinition from "slotworks/model/slot-definition";

export default class BetOptions {

    public lines: number;
    public lineValues: number[];
    public maxLines: number;

    public stakePerLine: number;
    public stakePerLineValues: number[];

    public coinSize: number;
    public coinSizes: number[];

    public totalStakeValues: number[];

    public stepper: Map<number, Stepper>;

    public getTotalStakeValues(): number[] {
        if (!this.totalStakeValues) {
            this.totalStakeValues = [];

            for (const coinSize of this.coinSizes) {
                for (const stakePerLine of this.stakePerLineValues) {
                    const stake = Math.round(stakePerLine * coinSize * this.lines * 100) / 100;
                    if (this.totalStakeValues.indexOf(stake) === -1) {
                        this.totalStakeValues.push(stake);
                    }
                }
            }

            // Sort ascending
            this.totalStakeValues.sort((a, b) => a - b);
        }

        return this.totalStakeValues;
    }
    
    public setTotalStake(value: number, lockCoinSize: boolean = false) {
        if(this.stepper != null && this.stepper.size > 0) {
            if(this.stepper.has(value)) {
                const step = this.stepper.get(value);
                this.coinSize = slotDefinition.coinSizes[step.coin_level - 1];
                this.stakePerLine = slotDefinition.stakes[step.bet_level - 1];
                return;
            }
            return;
        }
        for (const coinSize of this.coinSizes) {
            if (lockCoinSize && coinSize !== this.coinSize) {
                continue;
            }
            for (const stakePerLine of this.stakePerLineValues) {
                const stake = stakePerLine * coinSize * this.lines;
                // Avoid floating point errors
                if (Math.abs(Math.round(stake * 100 - value * 100)) < 1) {
                    this.coinSize = coinSize;
                    this.stakePerLine = stakePerLine;
                    return;
                }
            }
        }
    }

    public getTotalStake(): number {
        let lines = this.lines;
        if (lines <= 0) {
            lines = 1;
        }

        return Math.round(this.stakePerLine * this.coinSize * lines * 100) / 100;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/betbar/vo/bet-options.ts